'use client'
import {HgDisclaimer, HgThemeSelector} from '~/design-system/hg/components'
import type {HgHeroProps} from '../../types'
import {cn} from '~/design-system/utils'
import {useLayoutEffect, useRef} from 'react'

type HeroDisclaimerProps = {
  disclaimer?: HgHeroProps['disclaimer']
  className?: string
}

export function Disclaimer({disclaimer, className}: HeroDisclaimerProps) {
  const disclaimerRef = useRef<HTMLDivElement>(null)

  useLayoutEffect(() => {
    if (!disclaimerRef.current) return

    const updateHeight = () => {
      if (!disclaimerRef.current) return

      document.documentElement.style.setProperty(
        '--hero-disclaimer-height',
        `${disclaimerRef.current.clientHeight}px`
      )
    }

    updateHeight()
    const resizeObserver = new ResizeObserver(updateHeight)
    resizeObserver.observe(disclaimerRef.current)

    return () => resizeObserver.disconnect()
  }, [])

  if (!disclaimer) return null

  return (
    <HgThemeSelector theme="darkNeutral">
      <div
        ref={disclaimerRef}
        className={cn(
          'sticky inset-0 bottom-0 left-0 right-0 z-[3] col-start-1 row-start-1 mx-s5 flex justify-center self-end',
          className
        )}
      >
        <HgDisclaimer centered variant="contained" bottomSpacing="s5">
          {disclaimer}
        </HgDisclaimer>
      </div>
    </HgThemeSelector>
  )
}
